import { render, staticRenderFns } from "./AccountTaskList.vue?vue&type=template&id=a27c4904"
import script from "./AccountTaskList.vue?vue&type=script&lang=js"
export * from "./AccountTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports